module.exports = __webpack_public_path__ + "img/portrait-015.51113927.jpg";